import type { IExercise } from '../exercises';

export const ARCHIVED_LEGS_TEACHINGS: IExercise[] = [
  {
    "id": "hip-adductor-machine",
    "name": "仰卧髋内收器械",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "glutes",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["臀大肌","腘绳肌"],
    "demoUrl": "/media/gifs/hip-adductor-machine",
    "videoUrl": "/media/videos/hip-adductor-machine",
  },
  {
    "id": "side-lying-hip-adduct",
    "name": "侧卧髋内收",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "glutes",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["臀大肌","腘绳肌"],
    "demoUrl": "/media/gifs/side-lying-hip-adduct",
    "videoUrl": "/media/videos/side-lying-hip-adduct",
  },
  {
    "id": "bulgarian-split-squat",
    "name": "保加利亚分腿蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "glutes",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧8-10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["臀大肌","腘绳肌"],
    "demoUrl": "/media/gifs/bulgarian-split-squat",
    "videoUrl": "/media/videos/bulgarian-split-squat",
  },
  {
    "id": "single-leg-dumbbell-dl",
    "name": "单腿哑铃硬拉",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "hamstrings",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["腘绳肌","臀大肌"],
    "demoUrl": "/media/gifs/single-leg-dumbbell-dl",
    "videoUrl": "/media/videos/single-leg-dumbbell-dl",
  },
  {
    "id": "dumbbell-lunge",
    "name": "哑铃弓步蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "quadriceps",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["股四头肌","臀大肌"],
    "demoUrl": "/media/gifs/dumbbell-lunge",
    "videoUrl": "/media/videos/dumbbell-lunge",
  },
  {
    "id": "standing-calf-raise",
    "name": "站姿提踵",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "calves",
    "tips": ["核心收紧，控制动作节奏","全程保持稳定"],
    "sets": 4,
    "reps": "15-20",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["腓肠肌","比目鱼肌"],
    "demoUrl": "/media/gifs/standing-calf-raise",
    "videoUrl": "/media/videos/standing-calf-raise",
  },
  {
    "id": "single-leg-dl-glute",
    "name": "单腿哑铃硬拉",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "glutes",
    "tips": ["Day4 热身用：低强度激活腘绳+臀部","单腿支撑，髋部水平后推，控制节奏"],
    "sets": 2,
    "reps": "每侧10",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["臀大肌","腘绳肌"],
    "demoUrl": "/media/gifs/single-leg-dl-glute",
    "videoUrl": "/media/videos/single-leg-dl-glute",
  },
  {
    "id": "home-bulgarian-split-squat-v2",
    "name": "保加利亚分腿蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "glutes",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["臀大肌","腘绳肌"],
    "demoUrl": "/media/gifs/home-bulgarian-split-squat-v2",
    "videoUrl": "/media/videos/home-bulgarian-split-squat-v2",
  },
  {
    "id": "home-glute-bridge-v2",
    "name": "臀桥",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "glutes",
    "tips": ["核心收紧，控制动作节奏","全程保持稳定"],
    "sets": 4,
    "reps": "15-20",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["臀大肌","腘绳肌"],
    "demoUrl": "/media/gifs/home-glute-bridge-v2",
    "videoUrl": "/media/videos/home-glute-bridge-v2",
  },
  {
    "id": "home-goblet-squat",
    "name": "高脚杯深蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "quadriceps",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["股四头肌","臀大肌"],
    "demoUrl": "/media/gifs/home-goblet-squat",
    "videoUrl": "/media/videos/home-goblet-squat",
  },
  {
    "id": "ksw-single-leg-bulgarian",
    "name": "单腿保加利亚蹲",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "quads-glutes",
    "tips": ["后脚高架在凳上，前腿下蹲","膝盖对准脚尖，重心在前脚脚跟"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["股四头肌","臀大肌"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-single-leg-bulgarian",
    "videoUrl": "/media/videos/ksw-single-leg-bulgarian",
  },
  {
    "id": "ksw-barbell-rdl",
    "name": "杠铃罗马尼亚硬拉",
    "bodyPart": "legs",
    "equipment": "barbell",
    "subCategory": "hamstrings-glutes",
    "tips": ["髋部后推，杠铃沿大腿前侧下放","感受腘绳肌强烈拉伸，臀部发力拉起"],
    "sets": 3,
    "reps": "15",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["腘绳肌","臀大肌"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-barbell-rdl",
    "videoUrl": "/media/videos/ksw-barbell-rdl",
  },
  {
    "id": "ksw-back-extension",
    "name": "山羊挺身",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "lower-back",
    "tips": ["大腿前侧贴垫，髋部折叠下俯","起身时感受下背和臀部收紧，不超伸"],
    "sets": 3,
    "reps": "8",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "intermediate",
    "targetMuscles": ["竖脊肌","下背部肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-back-extension",
    "videoUrl": "/media/videos/ksw-back-extension",
  },
  {
    "id": "ksw-warmup-dynamic-frog",
    "name": "动态青蛙趴",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "髋",
    "tips": ["蛙式下蹲+动态弹动，打开髋内收","膝盖打开对准脚尖，重心下沉"],
    "sets": 2,
    "reps": "15",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-dynamic-frog",
    "videoUrl": "/media/videos/ksw-warmup-dynamic-frog",
  },
  {
    "id": "ksw-warmup-hip-90-90",
    "name": "髋关节90/90",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "髋",
    "tips": ["坐姿两腿各 90°，身体前后倾","打开髋内旋和外旋活动度，每侧各 10 次"],
    "sets": 2,
    "reps": "每侧10",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-hip-90-90",
    "videoUrl": "/media/videos/ksw-warmup-hip-90-90",
  },
  {
    "id": "ksw-warmup-foam-calf",
    "name": "泡沫轴松解-小腿",
    "bodyPart": "legs",
    "equipment": "foam-roller",
    "subCategory": "松解",
    "tips": ["泡沫轴放小腿下方，缓慢滚动","找到酸痛点停留 20-30 秒"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-foam-calf",
    "videoUrl": "/media/videos/ksw-warmup-foam-calf",
  },
  {
    "id": "ksw-warmup-foam-quad",
    "name": "泡沫轴松解-大腿",
    "bodyPart": "legs",
    "equipment": "foam-roller",
    "subCategory": "松解",
    "tips": ["俯卧，泡沫轴放大腿前侧","股四头肌全面滚动松解，1-2 分钟"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-foam-quad",
    "videoUrl": "/media/videos/ksw-warmup-foam-quad",
  },
  {
    "id": "ksw-warmup-foam-glute",
    "name": "泡沫轴松解-屁股",
    "bodyPart": "legs",
    "equipment": "foam-roller",
    "subCategory": "松解",
    "tips": ["坐泡沫轴上，侧偏臀部滚动","松解臀大肌和臀中肌，1-2 分钟"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-foam-glute",
    "videoUrl": "/media/videos/ksw-warmup-foam-glute",
  },
  {
    "id": "ksw-warmup-foam-tfl",
    "name": "泡沫轴松解-阔筋膜张肌",
    "bodyPart": "legs",
    "equipment": "foam-roller",
    "subCategory": "松解",
    "tips": ["侧卧，泡沫轴放髋外侧阔筋膜张肌","缓慢滚动，紧张点停留呼吸"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-foam-tfl",
    "videoUrl": "/media/videos/ksw-warmup-foam-tfl",
  },
  {
    "id": "ksw-warmup-foam-tibialis",
    "name": "泡沫轴松解-胫骨前肌",
    "bodyPart": "legs",
    "equipment": "foam-roller",
    "subCategory": "松解",
    "tips": ["小腿前侧胫骨前肌放泡沫轴上","缓慢滚动，放松胫骨前肌"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-foam-tibialis",
    "videoUrl": "/media/videos/ksw-warmup-foam-tibialis",
  },
  {
    "id": "threeway-lying-leg-curl",
    "name": "俯身腿弯举",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "hamstrings",
    "tips": ["臀部贴紧凳面","感受腘绳肌收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-lying-leg-curl",
    "videoUrl": "/media/videos/threeway-lying-leg-curl",
  },
  {
    "id": "threeway-rhino-squat",
    "name": "犀牛蹲",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "quads",
    "tips": ["重心前移","膝盖朝脚尖方向"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "demoUrl": "/media/videos/threeway-rhino-squat",
    "videoUrl": "/media/videos/threeway-rhino-squat",
  },
  {
    "id": "threeway-bulgarian-squat",
    "name": "保加利亚蹲",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "quads-glutes",
    "tips": ["前腿承重为主","下蹲至大腿平行"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "demoUrl": "/media/videos/threeway-bulgarian-squat",
    "videoUrl": "/media/videos/threeway-bulgarian-squat",
  },
  {
    "id": "personal-s1-glute-stretch",
    "name": "臀大肌拉伸",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "glutes",
    "tips": ["腰背平直，臀部后坐","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-glute-stretch",
    "videoUrl": "/media/videos/personal-s1-glute-stretch",
  },
  {
    "id": "personal-s1-hamstring-stretch",
    "name": "大腿后侧拉伸",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "legs",
    "tips": ["膝盖微屈不过伸","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-hamstring-stretch",
    "videoUrl": "/media/videos/personal-s1-hamstring-stretch",
  },
  {
    "id": "personal-s1-quad-stretch",
    "name": "大腿前侧拉伸",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "legs",
    "tips": ["膝盖指向地面不外翻","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-quad-stretch",
    "videoUrl": "/media/videos/personal-s1-quad-stretch",
  },
  {
    "id": "personal-s1-calf-stretch",
    "name": "小腿拉伸",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "calves",
    "tips": ["脚跟踩实，感受小腿后侧拉伸","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-calf-stretch",
    "videoUrl": "/media/videos/personal-s1-calf-stretch",
  },
  {
    "id": "personal-s6-adductor",
    "name": "内收肌训练",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "inner-thigh",
    "tips": ["内收时感受大腿内侧挤压","控制回放"],
    "sets": 3,
    "reps": "12",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s6-adductor",
    "videoUrl": "/media/videos/personal-s6-adductor",
  },
  {
    "id": "personal-s6-bulgarian-squat",
    "name": "保加利亚深蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "quads",
    "tips": ["前腿膝盖不超过脚尖","核心收紧保持平衡"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s6-bulgarian-squat",
    "videoUrl": "/media/videos/personal-s6-bulgarian-squat",
  },
  {
    "id": "personal-s6-dumbbell-rdl",
    "name": "哑铃硬拉",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "hamstrings",
    "tips": ["屈髋主导，感受腘绳肌延展","腰背全程平直"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s6-dumbbell-rdl",
    "videoUrl": "/media/videos/personal-s6-dumbbell-rdl",
  },
  {
    "id": "personal-s6-hip-flexor-raise",
    "name": "屈髋抬腿",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "hip-flexor",
    "tips": ["核心收紧不塌腰","感受髋屈肌发力"],
    "sets": 3,
    "reps": "12",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s6-hip-flexor-raise",
    "videoUrl": "/media/videos/personal-s6-hip-flexor-raise",
  },
  {
    "id": "fanjue-bulgarian-squat",
    "name": "保加利亚蹲",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "quads-glutes",
    "tips": ["前腿膝盖不超脚尖","重心在前脚"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "demoUrl": "/media/gifs/fanjue-bulgarian-squat",
    "videoUrl": "/media/videos/fanjue-bulgarian-squat",
  },
  {
    "id": "fanjue-gluteus-minimus-activation",
    "name": "臀中肌臀小肌激活",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["蚌式等臀部激活","感受臀中肌收缩"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-gluteus-minimus-activation",
    "videoUrl": "/media/videos/fanjue-gluteus-minimus-activation",
  },
  {
    "id": "fanjue-bulgarian-glute",
    "name": "保加利亚蹲",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "quads-glutes",
    "tips": ["侧重臀部版本","重心后移"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "demoUrl": "/media/gifs/fanjue-bulgarian-glute",
    "videoUrl": "/media/videos/fanjue-bulgarian-glute",
  },
  {
    "id": "fanjue-wide-body-function",
    "name": "宽身功能训练",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "hamstrings",
    "tips": ["宽距下肢功能训练","后侧链为主"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "demoUrl": "/media/gifs/fanjue-wide-body-function",
    "videoUrl": "/media/videos/fanjue-wide-body-function",
  },
  {
    "id": "fanjue-leg-warmup",
    "name": "腿部热身",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["下肢动态热身","关节活动+肌肉激活"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-leg-warmup",
    "videoUrl": "/media/videos/fanjue-leg-warmup",
  },
  {
    "id": "fanjue-bulgarian-leg",
    "name": "保加利亚蹲",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "quads-glutes",
    "tips": ["腿部主导版本","股四头侧重"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "demoUrl": "/media/gifs/fanjue-bulgarian-leg",
    "videoUrl": "/media/videos/fanjue-bulgarian-leg",
  },
  {
    "id": "fanjue-seated-leg-extension",
    "name": "坐姿腿屈伸",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "quadriceps",
    "tips": ["坐姿腿屈伸","股四头孤立"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-seated-leg-extension",
    "videoUrl": "/media/videos/fanjue-seated-leg-extension",
  },
];
